import { colors } from "./config";

export const Text = {
  baseStyle: {
    color: colors.text.base,
  },
  variants: {
    label: {
      fontWeight: 500,
    },
    secondary: {
      color: colors.text.secondary,
    },
    'with-dark-bg': {
      color: 'white',
    },
    'inline-link': {
      textDecoration: 'underline',
      color: 'brand.500',
      cursor: 'pointer',
      _hover: {
        color: 'brand.800',
      }
    }
  },
  sizes: {
    xl: { fontSize: "xl", lineHeight: 1.5 },
    lg: { fontSize: "lg", lineHeight: 1.5 },
    md: { fontSize: "md", lineHeight: 1.5 },
    sm: { fontSize: "sm", lineHeight: 1.5 },
    xs: { fontSize: "xs", lineHeight: 1.5 },
  }
};

export const Heading = {
  baseStyle: {
    fontWeight: 700,
    color: "text.800",
  },
  variants: {
    grey: {
      color: 'text.500',
    },
    'auth-title': {
      marginTop: 2,
      marginBottom: 0,
      textAlign: 'center',
      color: 'alt.500',
    },
    alt: {
      color: 'alt.500',
    },
  },
}
